import { IBaseEntity } from './base';
import { ITranscription, ITranscriptionDAO } from './transcription';

export interface IVideo extends IBaseEntity {
  name: string;
  description: string;
  transcriptionId: number;
  videoDataId: number;
  resolution: number;
  width: number;
  height: number;
  bitrate: number;
  orientation: number;
  duration: number;
  rotation: number;
}

export interface IVideoDAO extends IVideo {
  name: string;
  description: string;
  transcription: ITranscription;
  files: IVideoFile[];
}

export interface IVideoFile extends IBaseEntity {
  videoId: number;
  type: VideoType;
  templateId: number;
  filename: string;
  size: number;
  resolution: number;
}

export enum VideoType {
  DASH_264 = 0,
  HLS_264 = 1,
  IMAGE = 2,
  AUDIO = 3,
  DASH_265 = 4,
  HLS_265 = 5,
  DASH_WEBM = 6,
}

export interface IVideoGroup extends IBaseEntity {}

export interface IVideoTemplate extends IBaseEntity {
  videoGroupId: number;
  resolution: number;
  width: number;
  height: number;
  bitrate: number;
}
